export default {
  KLANT: 1,
  BANKZAKEN: 2,
  POLISSEN: 3,
  SCHADES: 4,
  HYPOTHEKEN: 5,
  KREDIETEN: 8,
  TENANT: 14,
  AGENCY: 15,
};
